import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingSupplierActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				menu="PUR03"
				name="PurchasingSupplier"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingSupplier"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingSupplierActivity)
